import { useState } from 'react';
import FiltersUtils from 'Utils/FiltersUtils';
import { filtersName } from './constants';

const INIT_FILTER = {
  client: [],
  expedition: [],
  paymentMode: [],
  city: [],
  zone: [],
  commercial: [],
  numCommande: '',
  numExpedition: '',
  type: null,
  deposit: null,
  controlled: null,
  startDate: null,
  endDate: null,
  sort: {},
};
const useAppliedFilter = () => {
  const savedFilters = FiltersUtils.getSavedFilters(filtersName);
  const [values, setValues] = useState(savedFilters || INIT_FILTER);
  const [appliedFilter, setAppliedFilter] = useState(savedFilters || INIT_FILTER);

  const handleRefresh = () => {
    setValues(INIT_FILTER);
    setAppliedFilter(INIT_FILTER);
    FiltersUtils.removeFilters(filtersName);
  };

  const onHandleSubmitFilters = () => {
    setAppliedFilter(values);
  };
  return {
    handleRefresh,
    values,
    setValues,
    appliedFilter,
    onHandleSubmitFilters,
  };
};

export default useAppliedFilter;
